var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMalawi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 17.9571 0.352063 19.8319 0.995188 21.5652L16 22.2609L31.0048 21.5652C31.648 19.8319 32 17.9571 32 16C32 14.0429 31.648 12.1681 31.0048 10.4348L16 9.73914L0.995188 10.4348C0.352063 12.1681 0 14.0429 0 16H0Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 0C9.12074 0 3.25605 4.342 0.995361 10.4348H31.005C28.7443 4.342 22.8796 0 16.0002 0V0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.005 21.5652H0.995361C3.25605 27.6579 9.12074 32 16.0002 32C22.8796 32 28.7443 27.6579 31.005 21.5652Z",
    fill: "#496E2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7816 7.65222L18.8276 6.73309L19.8682 4.84065L17.7463 5.24659L17.4775 3.10297L15.9995 4.67953L14.5215 3.10297L14.2526 5.24659L12.1308 4.84065L13.1713 6.73309L11.2173 7.65222H20.7816Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalawi);
export default __webpack_public_path__ + "static/media/malawi.750d734b.svg";
export { ForwardRef as ReactComponent };